export default {
  methods: {
    validateEmail (email) {
      return /\S+@\S+\.\S+/.test(email);
    }
  }
};
